/**
 * Логический размер слайда. **Лист без единого импорта, и в этом весь смысл
 * файла.**
 *
 * Число одно на всех: рисунок преподавателя с ноутбука обязан оказаться в том же
 * месте слайда у ученика с телефона, а подгонка координат под вьюпорт превратила
 * бы «вот здесь ошибка» в указание не туда. Схема слайда (`./slides.ts`) и
 * геометрия новой коробки (`./exercise-frame.ts`) читают эти два числа обе.
 *
 * ⚠️ **Отдельный модуль, потому что прямого пути между двумя читателями нет.**
 * `slides.ts` импортирует `exercises.ts` (ему нужны `ExerciseElement` и
 * `SLIDE_MAX_EXERCISES` на уровне модуля), поэтому обратный импорт замкнул бы
 * кольцо и упал бы в TDZ. До 03.09.2026 из-за этого размер слайда стоял в
 * геометрии своими литералами, а совпадение с настоящим держал тест. Лист
 * снимает и дубль, и замок к нему: импортировать его может кто угодно, потому
 * что он не импортирует никого. Приём в проекте уже применён, `oge/plan-picks.ts`
 * выехал из-за барьера ровно так же.
 *
 * Реэкспортируется из `./slides.ts`, чтобы у читателей барреля имя осталось на
 * прежнем месте: `import { SLIDE_WIDTH } from "@edu/shared"` работал и работает.
 */

export const SLIDE_WIDTH = 1280;
export const SLIDE_HEIGHT = 720;
